import { render, staticRenderFns } from "./ReservationWait.vue?vue&type=template&id=68f761d8"
import script from "./ReservationWait.vue?vue&type=script&lang=js"
export * from "./ReservationWait.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports